import script from "./BidViewCorporateClient.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewCorporateClient.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewCorporateClient.vue?vue&type=style&index=0&id=1484a2ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1484a2ca"]])

export default __exports__